module.exports = __webpack_public_path__ + "static/media/ico_simulation_nose_slim.bf3ceab8.png";